(function () {
  'use strict';

  angular
    .module('app.routes', [
      'app.lazyload'
    ]);
})();
